// extracted by mini-css-extract-plugin
export default {"wrapper":"FixtureTeamsScoreTime_wrapper__IyTbC","inProccess":"FixtureTeamsScoreTime_inProccess__9oww4"};